import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import {PagerBackendProps} from "../../../../components/Pager";
import VehicleModel from "../../../../commons/model/VehicleModel";
import TaskVehicleModelList from "../../../../commons/ws/vehicleModel/TaskVehicleModelList";

interface InitialState {
    loading: boolean,
    vehicleModels: VehicleModel[],
    error: string,
    pager: PagerBackendProps,
}

const INITIAL_STATE: InitialState = {
    loading: false,
    vehicleModels: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1,
        total_elements: 0,
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskVehicleModelList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskVehicleModelList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskVehicleModelList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskVehicleModelList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            vehicleModels: payload.data,
            pager: payload.pager || oldState.pager
        }
    })

    .build()
